/**
 * SCRUM-236 (DS-015 §13.8) — Sparta's first react-intl provider.
 *
 * Mounts a single-locale (`en`) IntlProvider so the entity-change / Activity
 * surface can render `semanticLabelKey` and field labels via react-intl (D6).
 * Other surfaces are not yet internationalized; they continue to work unchanged
 * (react-intl only affects components that call `useIntl` / `<FormattedMessage>`).
 *
 * `onError` is deliberately quiet in production (a missing message must never
 * crash a render — fail-soft, DS-015 §13.8) and warns in dev so a missing
 * catalog entry is visible during development.
 */
import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { DEFAULT_LOCALE, EN_MESSAGES } from './messages/en.js';

function handleIntlError(error: { code: string; message: string }): void {
  // MISSING_TRANSLATION is expected to be caught by the catalog-coverage tests;
  // surface it loudly in dev, swallow in prod so a render never throws.
  if (import.meta.env?.DEV) {
    console.warn(`[i18n] ${error.code}: ${error.message}`);
  }
}

export function AppIntlProvider(props: { children: React.ReactNode }): React.ReactElement {
  return (
    <IntlProvider
      locale={DEFAULT_LOCALE}
      defaultLocale={DEFAULT_LOCALE}
      messages={EN_MESSAGES as Record<string, string>}
      onError={handleIntlError}
    >
      {props.children}
    </IntlProvider>
  );
}
